<template>
  <div class="pending-replacements-container">
    <div class="pending-replacements-control-section">
      <div class="pr-spacer"></div>
      <div class="pr-top-actions">
        <mds-button v-if="localPolicyOptions.options['submit-to-production']"
          id="submit-to-production" variation="primary"
          :disabled="!enableSubmit"
          @click="openSubmitModal"
        >
          Submit to Production
        </mds-button>
      </div>
    </div>
    <div class="pending-replacements-grid-section">
      <PendingReplacementsGrid
        @updateSelected="onSelectUpdate"
        @showToolTip="onShowTooltip"
        @hideToolTip="onHideTooltip"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
import { EventBus } from '@/utils/event-bus';
import PendingReplacementsGrid from '@/components/organisms/PendingReplacementsGrid';

export default {
  name: 'pending-replacements',
  data() {
    return {
      enableSubmit: false,
      selectedReplacements: [],
    };
  },
  components: {
    PendingReplacementsGrid,
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedTab: (state) => state.pending.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to both Views
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  created() {
    EventBus.$emit('search-clear');
  },
  methods: {
    onShowTooltip(event, status, orientation, size) {
      this.$emit('showTooltip', event, status, orientation, size);
    },
    onHideTooltip(event) {
      this.$emit('hideTooltip', event);
    },
    onSelectUpdate(selectedFunds) {
      if (selectedFunds.length > 0) {
        this.selectedReplacements = selectedFunds;
        this.enableSubmit = true;
      } else {
        this.enableSubmit = false;
      }
    },
    openSubmitModal() {
      this.$store.dispatch('openModal', {
        title: 'Submit Replacements',
        component: 'submit-replacements',
        data: this.selectedReplacements,
      });
    },
  },
};
</script>
<style lang="scss">
.pending-replacements-container {
  padding: $mds-space-inset-4-x;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-m;
  font-weight: $mds-font-weight-thin;
  height: 100%;
  overflow-y: auto;
}
.pending-replacements-control-section {
  display: flex;
  padding-top: 6px;
  .prgrid-itemcount {
    line-height: 30px;
  }
  .pr-spacer {
    flex-grow: 1;
  }
  .pr-top-actions {
    button {
      margin-left: $mds-space-inset-4-x;
    }
  }
}
.pending-replacements-grid-section {
  margin-top: $mds-space-inset-2-x;
}
</style>
